import Vue from 'vue'
import Router from 'vue-router'
import $store from '../store/index.js'

Vue.use(Router)

const routes = [{
    path: '/',
    name: 'home',
    // meta:{title_en:"Home",title_ch:'華亞金融集團'},
    component:resolve => require(['@/pages/home/home.vue'], resolve)
  },
  {
    path:'/Default.asp',
    name:'honggu',
    // meta:{title_en:"Home",title_ch:'華亞金融集團'},
    component:resolve => require(['@/pages/home/home.vue'], resolve)
  },
  {//風險披露
    path: '/HKIDR',
    name: 'HKIDR',
    component:resolve => require(['@/pages/home/HKIDR.vue'], resolve)
  },
  {
    path: '/sreachpage',
    name: 'sreachpage',
    component:resolve => require(['@/pages/sreachpage/sreachpage.vue'], resolve)
  },
  {//風險披露
    path: '/risk_disclosure_statement',
    name: 'risk_disclosure_statement',
    meta:{title_en:"Risk Disclosure Statement",title_ch:'風險披露聲明'},
    component:resolve => require(['@/pages/safenotice&advice/riskdisclaimer.vue'], resolve)
  },
  {//隱私條例
    path: '/privacy_policy',
    name: 'privacy_policy',
    meta:{title_en:"Privacy Data Policy",title_ch:'私隱政策'},
    component:resolve => require(['@/pages/safenotice&advice/privacypolicy.vue'], resolve)
  },
  {//个人声明
    path: '/privacy_data_policy',
    name: 'privacy_data_policy',
    meta:{title_en:"Personal Data Collection Statement",title_ch:'收集個人資料聲明'},
    component:resolve => require(['@/pages/safenotice&advice/personalStatement.vue'], resolve)
  },
  {
    path: '/products&services',
    name: 'products',
    meta:{title_en:"Products & Services",title_ch:'產品及服務'},
    component:resolve => require(['@/pages/products/products.vue'], resolve)
  },
  {
    path: '/fund_products',
    name: 'fund_products',
    component:resolve => require(['@/pages/bondfund/boundfund.vue'], resolve)
  },
  {
    path: '/hyperlink_policy',
    name: 'hyperlink_policy',
    meta:{title_en:"Hyperlink Policy",title_ch:'超連結政策'},
    component:resolve => require(['@/pages/safenotice&advice/hyperlinkpolicy.vue'], resolve)
  },
  {
    path: '/ro-type149',
    name: 'ro-type149',
    component:resolve => require(['@/pages/joinus/ro-type149.vue'], resolve)
  },
  {
    path: '/ro-type1',
    name: 'ro-type1',
    component:resolve => require(['@/pages/joinus/ro-type1.vue'], resolve)
  },
  {
    path: '/join_us',
    name: 'join_us',
    meta:{title_en:"Join Us",title_ch:'就業機會'},
    component:resolve => require(['@/pages/joinus/joinus.vue'], resolve)
  },
  {
    path: '/security_usage_tips',
    name: 'security_usage_tips',
    meta:{title_en:"Security Usage Tips",title_ch:'安全性使用提示'},
    component:resolve => require(['@/pages/safenotice&advice/safenotice&advice.vue'], resolve)
  },
  {
    path: '/terms_&_conditions_of_use',
    name: 'terms_&_conditions_of_use',
    meta:{title_en:"Terms & Conditions of Use",title_ch:'一般條款及細則'},
    component:resolve => require(['@/pages/safenotice&advice/terms&conditions.vue'], resolve)
  },
  {
    path: '/global-stocks',
    name: 'hongkong',
    component:resolve => require(['@/pages/home/compoents/hongkong.vue'], resolve)
  },
  {
    path:'/hksecurities_introduction',
    name:'honggu',
    meta:{title_en:"Hong Kong Securities | Market Introduction",title_ch:'香港證券 | 市場介紹'},
    component:resolve => require(['@/pages/home/compoents/honggu.vue'],resolve)
  },
  {
    path:'/hksecurities_information',
    name:'hongjiaoyi',
    meta:{title_en:"Hong Kong Securities | Trading Information",title_ch:'香港證券 | 交易須知'},
    component:resolve => require(['@/pages/home/compoents/hongjiaoyi.vue'],resolve)
  },
  {
    path:'/hksecurities_fees',
    name:'hongfuwu',
    meta:{title_en:"Hong Kong Securities | Services Fees",title_ch:'香港證券 | 服務收費'},
    component:resolve => require(['@/pages/home/compoents/hongfuwu.vue'],resolve)
  },
  {
    path:'/ussecurities_introduction',
    name:'usagu',
    meta:{title_en:"US Stocks | Market Introduction",title_ch:'美國股票 | 市場介紹'},
    component:resolve => require(['@/pages/usapage/usagu.vue'],resolve)
  },
  {
    path:'/ussecurities_information',
    name:'usajiaoyi',
    meta:{title_en:"US Stocks | Trading Information",title_ch:'美國股票 | 交易須知'},
    component:resolve => require(['@/pages/usapage/usajiaoyi.vue'],resolve)
  },
  {
    path:'/ussecurities_fees',
    name:'usafuwu',
    meta:{title_en:"US Stocks | Services Fees",title_ch:'美國股票 | 服務收費'},
    component:resolve => require(['@/pages/usapage/usafuwu.vue'],resolve)
  },
  {
    path:'/ussecurities_security',
    name:'ussecurities_security',
    meta:{title_en:"US Stocks | Securities transfer",title_ch:'美國股票 | 證券轉倉'},
    component:resolve => require(['@/pages/usapage/usazc.vue'],resolve)
  },
  {
    path:'/transferring_questionnaire',
    name:'transferring_questionnaire',
    meta:{title_en:"questionnaire",title_ch:'轉倉問卷'},
    component:resolve => require(['@/pages/usapage/zcProblem.vue'],resolve)
  },
  {
    path:'/fund_introduction',
    name:'bondjiaoyi',
    meta:{title_en:"Fund Services",title_ch:'基金服務'},
    component:resolve => require(['@/pages/bondfund/bondjiaoyi.vue'],resolve)
  },
  {
    path:'/bonds_introduction',
    name:'bondfund',
    meta:{title_en:"Bond Services",title_ch:'債券服務'},
    component:resolve => require(['@/pages/bondfund/bondfund.vue'],resolve)
  },
  {
    path:'/bonds_products',
    name:'bondProducts',
    meta:{title_en:"Bond Services",title_ch:'債券服務'},
    component:resolve => require(['@/pages/bondfund/bondProducts.vue'],resolve)
  },
  {
    path:'/fund_questionnaire',
    name:'fund_questionnaire',
    meta:{title_en:"fund",title_ch:'基金問卷'},
    component:resolve => require(['@/pages/bondfund/fundProblem.vue'],resolve)
  },
  {
    path:'/bonds_questionnaire',
    name:'bonds_questionnaire',
    meta:{title_en:"bond",title_ch:'債券問卷'},
    component:resolve => require(['@/pages/bondfund/bondProblem.vue'],resolve)
  },
  {
    path:'/bonds_subscription',
    name:'bonds_subscription',
    meta:{title_en:"bond",title_ch:'債券問卷'},
    component:resolve => require(['@/pages/bondfund/bonds_subscription.vue'],resolve)
  },
  {
    path:'/fund_subscription',
    name:'fund_subscription',
    meta:{title_en:"bond",title_ch:'基金問卷'},
    component:resolve => require(['@/pages/bondfund/fund_subscription.vue'],resolve)
  },
  {
    path:'/ipo_subscriptions',
    name:'newshares',
    meta:{title_en:"IPO Subscriptions",title_ch:'新股認購'},
    component:resolve => require(['@/pages/newshares/newshares.vue'],resolve)
  },
  {
    path:'/newcalendar',
    name:'newcalendar',
    component:resolve => require(['@/pages/newshares/newcalendar.vue'],resolve)
  },{
    path:'/securities_transfer',
    name:'zhuancang',
    meta:{title_en:"Securities Transfer",title_ch:'證券轉倉'},
    component:resolve => require(['@/pages/zhuancang/zhuancang.vue'],resolve)
  },{
    path:'/sgsecurities_introduction',
    name:'xinjiapo',
    meta:{title_en:"Singapore Stocks | Market Introduction",title_ch:'新加坡股 | 市場介紹'},
    component:resolve => require(['@/pages/xinjiapo/xinjiapo.vue'],resolve)
  },{
    path:'/sgsecurities_information',
    name:'xinjiapojiaoyi',
    meta:{title_en:"Singapore Stocks | Trading Information",title_ch:'新加坡股 | 交易須知'},
    component:resolve => require(['@/pages/xinjiapo/xinjiapojiaoyi.vue'],resolve)
  },{
    path:'/sgsecurities_fees',
    name:'xinjiapofuwu',
    meta:{title_en:"Singapore Stocks | Services Fees",title_ch:'新加坡股 | 服務收費'},
    component:resolve => require(['@/pages/xinjiapo/xinjiapofuwu.vue'],resolve)
  },{
    path:'/jpsecurities_introduction',
    name:'japan',
    meta:{title_en:"Japan Stocks | Market Introduction",title_ch:'日股 | 市場介紹'},
    component:resolve => require(['@/pages/japan/japan.vue'],resolve)
  },{
    path:'/jpsecurities_fees',
    name:'japanfuwu',
    meta:{title_en:"Japan Stocks | Services Fees",title_ch:'日股 | 服務收費'},
    component:resolve => require(['@/pages/japan/japanfuwu.vue'],resolve)
  },{
    path:'/jpsecurities_information',
    name:'japanjiaoyi',
    meta:{title_en:"Japan Stocks | Trading Information",title_ch:'日股 | 交易須知'},
    component:resolve => require(['@/pages/japan/japanjiaoyi.vue'],resolve)
  },
  {
    path:'/gesecurities_introduction',
    name:'germany',
    meta:{title_en:"Germany Stocks | Market Introduction",title_ch:'德股 | 市場介紹'},
    component:resolve => require(['@/pages/germany/germany.vue'],resolve)
  },{
    path:'/gesecurities_information',
    name:'germanyjiaoyi',
    meta:{title_en:"Germany Stocks | Trading Information",title_ch:'德股 | 交易須知'},
    component:resolve => require(['@/pages/germany/germanyjiaoyi.vue'],resolve)
  },{
    path:'/gesecurities_fees',
    name:'germanyfuwu',
    meta:{title_en:"Germany Stocks | Services Fees",title_ch:'德股 | 服務收費'},
    component:resolve => require(['@/pages/germany/germanyfuwu.vue'],resolve)
  },
  {
    path:'/ausecurities_introduction',
    name:'austock',
    meta:{title_en:"Australia Stocks | Market Introduction",title_ch:'澳洲股 | 市場介紹'},
    component:resolve => require(['@/pages/austock/austock.vue'],resolve)
  },{
    path:'/ausecurities_information',
    name:'austockjiaoyi',
    meta:{title_en:"Australia Stocks | Trading Information",title_ch:'澳洲股 | 交易須知'},
    component:resolve => require(['@/pages/austock/austockjiaoyi.vue'],resolve)
  },{
    path:'/ausecurities_fees',
    name:'austockfuwu',
    meta:{title_en:"Australia Stocks | Services Fees",title_ch:'澳洲股 | 服務收費'},
    component:resolve => require(['@/pages/austock/austockfuwu.vue'],resolve)
  },
  {
    path:'/twsecurities_introduction',
    name:'twstock',
    meta:{title_en:"Taiwan Stocks | Market Introduction",title_ch:'台股 | 市場介紹'},
    component:resolve => require(['@/pages/twstock/twstock.vue'],resolve)
  },{
    path:'/twsecurities_fees',
    name:'twstockfuwu',
    meta:{title_en:"Taiwan Stocks | Services Fees",title_ch:'台股 | 服務收費'},
    component:resolve => require(['@/pages/twstock/twstockfuwu.vue'],resolve)
  },{
    path:'/twsecurities_information',
    name:'twstockjiaoyi',
    meta:{title_en:"Taiwan Stocks | Trading Information",title_ch:'台股 | 交易須知'},
    component:resolve => require(['@/pages/twstock/twstockjiaoyi.vue'],resolve)
  },{
    path:'/mysecurities_introduction',
    name:'mystock',
    meta:{title_en:"Malaysia Stocks | Market Introduction",title_ch:'馬來西亞股 | 市場介紹'},
    component:resolve => require(['@/pages/mystock/mystock.vue'],resolve)
  },{
    path:'/mysecurities_fees',
    name:'mystockfuwu',
    meta:{title_en:"Malaysia Stocks | Services Fees",title_ch:'馬來西亞股 | 服務收費'},
    component:resolve => require(['@/pages/mystock/mystockfuwu.vue'],resolve)
  },{
    path:'/mysecurities_information',
    name:'mystockjiaoyi',
    meta:{title_en:"Malaysia Stocks | Trading Information",title_ch:'馬來西亞股 | 交易須知'},
    component:resolve => require(['@/pages/mystock/mystockjiaoyi.vue'],resolve)
  },{
    path:'/stockconnect_introduction',
    name:'shstock',
    meta:{title_en:"Stock Connect | Market Introduction",title_ch:'滬深港通 | 市場介紹'},
    component:resolve => require(['@/pages/shstock/shstock.vue'],resolve)
  },{
    path:'/stockconnect_fees',
    name:'shstockfuwu',
    meta:{title_en:"Stock Connect | Services Fees",title_ch:'滬深港通 | 服務收費'},
    component:resolve => require(['@/pages/shstock/shstockfuwu.vue'],resolve)
  },{
    path:'/stockconnect_information',
    name:'shstockjiaoyi',
    meta:{title_en:"Stock Connect | Trading Information",title_ch:'滬深港通 | 交易須知'},
    component:resolve => require(['@/pages/shstock/shstockjiaoyi.vue'],resolve)
  },{
    path:'/services_fee',
    name:'hkstock',
    meta:{title_en:"Service Fees and Charges",title_ch:'服務收費'},
    component:resolve => require(['@/pages/hkstock/hkstock.vue'],resolve)
  },
  {
    path:'/apply_in_person_individual',
    name:'assetmanage',
    meta:{title_en:"Apply In Person | Individual Account",title_ch:'親臨開戶 | 個人帳戶'},
    component:resolve => require(['@/pages/assetmanage/assetmanage.vue'],resolve)
  },
  {
    path:'/apply_in_person_corporate',
    name:'caccount',
    meta:{title_en:"Apply In Person | Corporate Account",title_ch:'親臨開戶 | 公司帳戶'},
    component:resolve => require(['@/pages/assetmanage/caccount.vue'],resolve)
  },
  {
    path:'/asset_apply_in_person_individual',
    name:'asset_assetmanage',
    meta:{title_en:"Asset Management | Individual Account",title_ch:'資產管理 | 個人帳戶'},
    component:resolve => require(['@/pages/assetmanage/assetmanage_asset.vue'],resolve)
  },
  {
    path:'/asset_apply_in_person_corporate',
    name:'asset_caccount',
    meta:{title_en:"Asset Management | Corporate Account",title_ch:'資產管理 | 公司帳戶'},
    component:resolve => require(['@/pages/assetmanage/caccount_asset.vue'],resolve)
  },
  {
    path:'/sent_by_post_individual',
    name:'paccount',
    meta:{title_en:"Sent By Post | Individual Account",title_ch:'郵遞開戶 | 個人帳戶'},
    component:resolve => require(['@/pages/assetmanage/paccount.vue'],resolve)
  },{
    path:'/sent_by_post_corporate',
    name:'caccounts',
    meta:{title_en:"Sent By Post | Corporate Account",title_ch:'郵遞開戶 | 公司帳戶'},
    component:resolve => require(['@/pages/assetmanage/caccounts.vue'],resolve)
  },{
    path:'/account_opening_online',
    name:'videopage',
    meta:{title_en:"Account Opening APP",title_ch:'在線開戶'},
    component:resolve => require(['@/pages/assetmanage/videopage.vue'],resolve)
  },{
    path:'/account_opening_appointment',
    name:'makeappointment',
    meta:{title_en:"Appointment",title_ch:'預約開戶'},
    component:resolve => require(['@/pages/assetmanage/makeappointment.vue'],resolve)
  }
  ,{
    path:'/FAQs',
    name:'comproblem',
    meta:{title_en:"FAQs",title_ch:'常見問題'},
    component:resolve => require(['@/pages/comproblem/comproblem.vue'],resolve)
  },{
    path:'/market_data',
    name:'sujufuwu',
    meta:{title_en:"Market Data Service",title_ch:'數據服務'},
    component:resolve => require(['@/pages/sujufuwu/sujufuwu.vue'],resolve)
  },
  {
    path:'/deposit&withdrawal',
    name:'zijincunqu',
    meta:{title_en:"Deposit & Withdrawal",title_ch:'資金存取'},
    component:resolve => require(['@/pages/zijincunqu/zijincunqu.vue'],resolve)
  },
  {
    path:'/asset_deposit&withdrawal',
    name:'zijincunqu2',
    meta:{title_en:"Deposit & Withdrawal",title_ch:'資金存取'},
    component:resolve => require(['@/pages/zijincunqu/zijincunqu2.vue'],resolve)
  },
  {
    path:'/asset_download_form',
    name:'downtable',
    meta:{title_en:"Download Form",title_ch:'表格下載'},
    component:resolve => require(['@/pages/sujufuwu/downtable2.vue'],resolve)
  },
  {
    path:'/download_form',
    name:'downtable',
    meta:{title_en:"Download Form",title_ch:'表格下載'},
    component:resolve => require(['@/pages/sujufuwu/downtable.vue'],resolve)
  },{
    path:'/trading_announcement',
    name:'tonggao',
    meta:{title_en:"Trading Announcement",title_ch:'交易通告'},
    component:resolve => require(['@/pages/sujufuwu/tonggao.vue'],resolve)
  },{
    path:'/tongcom',
    name:'tongcom',
    component:resolve => require(['@/pages/sujufuwu/tongcom.vue'],resolve)
  },{
    path:'/market_holiday',
    name:'publicholidays',
    meta:{title_en:"Market Holiday",title_ch:'市場假期'},
    component:resolve => require(['@/pages/sujufuwu/publicholidays.vue'],resolve)
  },{
    path:'/contact_us',
    name:'contact_us',
    meta:{title_en:"Contact Us",title_ch:'聯絡我們'}, 
    component:resolve => require(['@/pages/contactus/contactus.vue'],resolve)
  },{
    path:'/about_us',
    name:'about_us',
    meta:{title_en:"About Us",title_ch:'關於我們'}, 
    component:resolve =>require(['@/pages/aboutus/aboutus.vue'],resolve)
  },{
    path:'/asset_management_introduction',
    name:'asset_management_introduction',
    meta:{title_en:"Asset Management | Introduction",title_ch:'資產管理 | 業務簡介'}, 
    component:resolve =>require(['@/pages/zichanguanli/zichanguanli.vue'],resolve)
  },{
    path:'/asset_management_services',
    name:'asset_management_services',
    meta:{title_en:"Asset Management | Products & Services",title_ch:'資產管理 | 產品及服務'}, 
    component:resolve => require(['@/pages/zichanguanli/touzi.vue'],resolve)
  },{
    path:'/caiwu',
    name:'caiwu',
    component:resolve => require(['@/pages/caiwu/caiwu.vue'],resolve)
  },{
    path:'/weituo',
    name:'weituo',
    component:resolve => require(['@/pages/weituo/weituo.vue'],resolve)
  },
   {
    path:'/trustees',
    name:'trustees',
    meta:{title_en:"Trustees",title_ch:'信托服務'}, 
    component:resolve => require(['@/pages/trustees/trustees.vue'],resolve)
  }
];

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}



const router = new Router({
  // 部署正式
  routes,
  base: '/', //正式
  // base: '/qmisgroup',  //测试
  // config 文件夹下 index.js 文件 assets文件 axiosconfig.js文件
  // mode: 'hash',
  mode: 'history',
  // scrollBehavior(to,from,savedPosition){
  //   console.log(savedPosition)
  //   if(savedPosition){
  //     return savedPosition
  //   }else{
  //     return {
  //       x:0,
  //       y:0
  //     }
  //   }
  // }
})

// routers = new Router({
router.beforeEach((to, from, next) => {
  if(to.name !=='publicholidays' && window.sessionStorage['p_days']){
    window.sessionStorage['p_days'] = ''
  }
  $store.commit('upisland',true)
  setTimeout(()=>{
    $store.commit('upisland',false)
  },500)
  var lang = localStorage['guanwanglang'] 
  if (lang == 'eng') {
    if(to.meta.title_en){
      document.title = to.meta.title_en + ' | QMIS Financial Group'
    }else{
      document.title = 'QMIS Financial Group'
    }
  }else{
    if(to.meta.title_ch){
      document.title = to.meta.title_ch + ' | 華亞金融集團'
    }else{
      document.title = '華亞金融集團'

    }
  }
  // const ogTitleMeta = document.querySelector(`meta[property="og:title"]`);
  // if (ogTitleMeta) {
  //   ogTitleMeta.content = document.title;
  // }
 
  // if(!window.localStorage.token&&from.path !=='/'){
  //   location.href = '/'
  //   next()
  // }else{
  next()
  // }
})



export default router;



// WEBPACK FOOTER //
// ./src/router/index.js